import React from "react";
import { useTranslation } from "react-i18next";

function SheetSelectionModal({ isOpen, sheetNames, onSelect, onCancel }) {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-2xl p-6 min-w-[350px] flex flex-col gap-4">
                <h3 className="text-xl font-bold text-gray-800">{t('importExportButtons.chooseSheet')}</h3>
                <p className="text-sm text-gray-600">{t('importExportButtons.multipleSheetHint')}</p>
                <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto">
                    {sheetNames.map((name) => (
                        <button
                            key={name}
                            type="button"
                            onClick={() => onSelect(name)}
                            className="w-full text-left px-4 py-3 rounded-lg border border-gray-200 hover:bg-blue-50 hover:border-blue-300 transition-colors flex items-center justify-between group"
                        >
                            <span className="font-medium group-hover:text-blue-700">{name}</span>
                            <span className="text-gray-400 text-sm">➔</span>
                        </button>
                    ))}
                </div>
                <button
                    type="button"
                    onClick={onCancel}
                    className="mt-2 text-gray-500 hover:text-gray-700 text-sm font-medium"
                >
                    {t('importExportButtons.cancelImport')}
                </button>
            </div>
        </div>
    );
}

export default SheetSelectionModal;
